import { getItemWebStorage, setItemSessionStorage } from "../../../../features/webStorageSaver"
import { setHighContrastModeIsEnabled, setPrintButtonIsClicked } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { store } from "../../../../stateManagement/store"

export function controlMapSettingsButton(navigate: any) {
    navigate('/app/mapSettings/map')
}

export function controlHighContrastModeButton() {
    const highContrastModeIsEnabled = store.getState().contentHeader.highContrastModeIsEnabled
    const { auxiliaryLayersDisplayState } = getItemWebStorage("mapSettings") ?? {}
    const { indorAvia: indorAviaLayerIsShown, esriWorldImagery: esriWorldImageryLayerIsShown } = auxiliaryLayersDisplayState ?? {}
    if (!indorAviaLayerIsShown && !esriWorldImageryLayerIsShown) {
        setItemSessionStorage('mapHighContrastModeIsEnabled', !highContrastModeIsEnabled)
        store.dispatch(setHighContrastModeIsEnabled(!highContrastModeIsEnabled))
    }
}

export function controlPrintButton() {
    store.dispatch(setPrintButtonIsClicked(true))
}